import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    logo: {
        margin: theme.spacing(1),
        width: "100%",
        height: "auto"
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loginError: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.common.white,
        height: '50px',
        fontSize: '16px',
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    signInLink: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 10,
        marginBottom: 10,
        padding: 5,
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.text.secondary,
        border: '1px solid',
        borderRadius: '5px',
    },
    signInSection: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.text.secondary,
        border: '1px solid',
        borderRadius: '5px',
        padding: 15
    },
    oidcSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        margin: 5,
    }
}));

export {useStyles};